import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-learnmore",
  "use": "icon-learnmore-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-learnmore\"><path fill-rule=\"evenodd\" d=\"M4 3.582A1.58 1.58 0 0 1 5.58 2h9.48c.873 0 1.58.708 1.58 1.582v12.654a1.58 1.58 0 0 1-1.58 1.582H5.58A1.58 1.58 0 0 1 4 16.236V3.582Zm11.06 0H5.58v12.654h9.48V3.582Zm-7.9 3.954a.79.79 0 0 1 .79-.79h4.74a.79.79 0 0 1 0 1.581H7.95a.79.79 0 0 1-.79-.79Zm.79 3.164a.79.79 0 0 0 0 1.582h2.37a.79.79 0 0 0 0-1.582H7.95Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol